import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68034772"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "text-info text-sm mt-s2" }

import BigNumber from 'bignumber.js';
import { computed, ref } from 'vue';
import roundMixin from '@/mixins/round.mixin';
import { documentStyles } from '@/composables/charts/useCharts';


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioUserShareChart',
  props: {
    userShare: null
  },
  setup(__props: any) {

const props = __props as {
  userShare: BigNumber;
}



const { mathMixRound } = roundMixin.methods;
const userSharePercent = computed(() => {
  if (props.userShare.eq(0)) {
    return '0%';
  }
  const percent = mathMixRound(props.userShare, 2);
  if (percent === '0') {
    return '< 0.01%';
  }
  return `${percent}%`;
});
const percents = computed(() => [
  props.userShare.plus(0.2).toNumber(),
  new BigNumber(100).minus(props.userShare).toNumber(),
]);

const chartData = computed(() => {
  return {
    labels: ['A', 'B'],
    datasets: [
      {
        data: percents.value,
        backgroundColor: [
          documentStyles.value.getPropertyValue('--info'),
          documentStyles.value.getPropertyValue('--front-10'),
        ],
        borderWidth: 0,
      },
    ],
  };
});
const chartOptions = ref({
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      enabled: false,
    },
  },
  cutout: '70%',
});

return (_ctx: any,_cache: any) => {
  const _component_Chart = _resolveComponent("Chart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Chart, {
      type: "doughnut",
      data: _unref(chartData),
      options: chartOptions.value,
      class: "chart-small"
    }, null, 8, ["data", "options"]),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(userSharePercent)), 1)
  ]))
}
}

})